import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { stringBuilder } from '../util';
const TuxTooltipBody = forwardRef(function TuxTooltipBody(props, ref) {
    const { arrowProps, children, className, id, isVisible = false, onClose, placement = 'right', popover = false, style } = props;
    const classes = stringBuilder({
        tooltip: !popover,
        [`bs-tooltip-${placement}`]: !popover,
        popover,
        [`bs-popover-${placement}`]: popover,
        fade: isVisible,
        show: isVisible
    }, className);
    return (_jsxs("div", Object.assign({ "aria-hidden": popover ? undefined : true, className: classes, "data-placement": placement, ref: ref, role: popover ? 'none' : 'tooltip', style: style }, { children: [_jsxs("div", Object.assign({ className: popover ? 'popover-body' : 'tooltip-inner' }, { children: [popover && (_jsx("button", { "aria-label": "close popover", className: "close", onClick: onClose, type: "button" }, void 0)), _jsx("span", Object.assign({ className: popover ? 'popover-text' : 'tooltip-text', id: id }, { children: children }), void 0)] }), void 0), _jsx("div", { "aria-hidden": "true", className: "arrow", ref: arrowProps.ref, style: arrowProps.style }, void 0)] }), void 0));
});
export default TuxTooltipBody;
